import React, { useEffect, useRef } from "react"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import ReactHtmlParser from "react-html-parser"
import { DateTime } from "luxon"
import Svg from "../_svgs/svg"

export default function JuicerFeedComponent({
  title,
  headline,
  juicerFeedScriptLink,
  postsDaysAmount,
  linkText,
  linkUrl,
  linkTarget,
  backgroundColor,
  topPadding,
  bottomPadding,
}) {
  const tp = SelectionFactoryHelper.getFromSelectionFactory(topPadding)
  const bp = SelectionFactoryHelper.getFromSelectionFactory(bottomPadding)
  const bgColor = SelectionFactoryHelper.getFromSelectionFactory(backgroundColor)
  const target = SelectionFactoryHelper.getFromSelectionFactory(linkTarget)

  const startDate = DateTime.now().minus({ days: postsDaysAmount }).toISODate()

  const feedRef = useRef(null)

  useEffect(() => {
    if (!juicerFeedScriptLink || !feedRef.current) return

    const separator = juicerFeedScriptLink.includes("?") ? "&" : "?"
    const scriptSrc = `${juicerFeedScriptLink}${separator}starting-at=${startDate}`

    feedRef.current.innerHTML = ""

    const scriptElement = document.createElement("script")
    scriptElement.src = scriptSrc
    scriptElement.async = true
    scriptElement.defer = true

    feedRef.current.appendChild(scriptElement)

    const observer = new MutationObserver(() => {
      const feedItems = feedRef.current.querySelectorAll(".feed-item.j-x-twitter")
      if (feedItems.length === 0) return

      feedItems.forEach((item) => {
        const dateElem = item.querySelector("time.j-twitter-date")
        const messageElem = item.querySelector(".j-message")
        if (!dateElem || !messageElem) return

        const dt = DateTime.fromISO(dateElem.getAttribute("datetime")).setLocale("da")
        const dateText = `${dt.toFormat("d LLLL yyyy")} - Kl. ${dt.toFormat("HH.mm")}`

        const newDateElem = document.createElement("div")
        newDateElem.className = "custom-twitter-date"
        newDateElem.innerText = dateText

        messageElem.prepend(newDateElem)

        // set tabindex="-1" on the <li class="feed-item"> itself:
        item.setAttribute("tabindex", "-1")

        // find all links inside .j-message and set tabindex="0":
        messageElem.querySelectorAll("a").forEach((link) => {
          link.setAttribute("tabindex", "0")
        })
      })

      observer.disconnect()
    })

    observer.observe(feedRef.current, {
      childList: true,
      subtree: true,
    })

    return () => observer.disconnect()
  }, [juicerFeedScriptLink, startDate])

  if (!juicerFeedScriptLink) return null

  return (
    <div className={`juicer-component ${tp || ""} ${bp || ""} ${bgColor || ""}`}>
      <div className="w--wider">
        {title && <div className="title">{title}</div>}
        {headline && <div className="headline rich-text">{ReactHtmlParser(headline)}</div>}
        <div className="feed" ref={feedRef} />
        {linkText && linkUrl && (
          <div className="profile-link">
            <a tabIndex={0} href={linkUrl} target={target ? target : undefined}>
              <Svg iconName={"arrowright-slim"} />
              {linkText}
            </a>
          </div>
        )}
      </div>
    </div>
  )
}
